<template>
  <section class='searchBar'>
    <img :src="logoUrl" v-if='logoUrl' style='width: 200px;height: 58px; cursor: pointer;' alt="爱排名" @click='gotoHome'>
    <img v-else='logoUrl' src="@/assets/images/logo5.png" style='width: 200px;height: 58px; cursor: pointer;' alt="爱排名" @click='gotoHome'>
    <div class='searchContent'>
      <ul class='serviceList'>
        <li v-for='item in serviceList' :key='item.id' @click='selectService(item)' :class="{active: item.active}">{{item.text}}</li>
      </ul>
      <p class='seoSearchBox'>
        <el-input v-model='searchContent' :placeholder="placeholderText"  @keyup.enter.native="search"></el-input>
        <span class='searchBtn' @click='search'>
          <i class='el-icon-search'></i>
        </span>
      </p>
    </div>
    <div class='phoneInfo'>
      <img src="../assets/images/phone.png" alt="联系方式">
      <p class='phoneNo'>
        <span>客服热线</span>
        <span>{{freeHotLine}}</span>
      </p>
    </div>
  </section>
</template>
<script>
  import { MessageBox, Message } from 'element-ui';
  import { Api } from '../service/api'
  export default {
    name: 'SearchBar',
    data() {
      return {
        placeholderText: '请输入网址搜索,如:www.baidu.com',
        searchContent: '',
        logoUrl: '',
        freeHotLine: '',
        serviceList: [
          {
            id: 1,
            text: '快速排名',
            active: true,
            placeholderText: '请输入网址搜索，如：www.baidu.com',
            pageUrl: '/index/result/list'
          },
          //   {
          //   id: 2,
          //   text: 'SEO优化',
          //   active: false,
          //   placeholderText: '多个关键字以英文逗号分隔,最多50个词 如:刷脸支付,印刷厂,装修公司',
          //   pageUrl: '/index/result/seo'
          // },
            {
            id: 3,
            text: '积分优化',
            active: false,
            placeholderText: '',
            // pageUrl: '/index/result/batch',
            pageUrl: '/dashboard/optimizeManagement/integrationOptimize'
          }, {
            id: 4,
            text: '案例查询',
            active: false,
            placeholderText: '请输入案例关键词',
            pageUrl: '/index/result/case'
          },
        ]
      }
    },
    methods: {
      selectService(item) {
        var temp = this.searchContent;

        if(item.active!=true){


            this.searchContent = ''
            this.searchContent = temp
        }
        console.log(item)
        if(item.text == '积分优化'){
          if(!localStorage.getItem('loginUsername')) {
            Message({
              showClose: true,
              message: '请先登录',
              type: 'success'
            })
            this.$router.push({
              path: '/'
            })
          }else{

            this.$router.push({
              path: '/dashboard/optimizeManagement/integrationOptimize'
            })
          }
        }

        this.serviceList.map((value) => {
          value.active = false;
          if(value.id == item.id) {
            value.active = true;
            this.placeholderText = value.placeholderText;
          }
        })
      },
      search() {
        if(!this.searchContent) {
          Message({
            showClose: true,
            message: '请填写要查询的内容',
            type: 'success'
          })
          return
        }

        for(let i=0; i<this.serviceList.length;i++){
          if(this.serviceList[i].active){

              localStorage.setItem('searchMainContent', this.searchContent)
              localStorage.setItem('searchModalIndex', i)
            //  alert( localStorage.getItem());
            // this.$router.push({
            //   path: this.serviceList[i].pageUrl
            // })
            window.open(this.serviceList[i].pageUrl,'_blank');
          }
        }

      },
      getPlaceholderText() {
        this.serviceList.map((value) => {
          if(value.active){
            this.placeholderText = value.placeholderText;
          }
        })
      },
      gotoHome() {
        this.$router.push({
          path: '/'
        })
      },
      getSiteInfo() {
        let params = {}
        Api.getSiteInfo(params).then((res) => {
          if(res.data.code == 1){
            if(res.data.data && res.data.data.logo){
              this.logoUrl = res.data.data.logo
              this.freeHotLine = res.data.data.free_hotline
            }
          }
        })
      }
    },
    mounted() {
      sessionStorage.removeItem('searchMainContent')
      sessionStorage.removeItem('searchModalIndex')
      this.getPlaceholderText();
      this.getSiteInfo()
    }
  }
</script>
<style scoped lang='scss'>
  section{
    padding: 10px 2.5rem 20px;
    background: #101317;
    display: flex;
    .searchContent{
      margin: 0 50px;
      width: 100%;
      .seoSearchBox{
        position: relative;
        left: 0;
        top: 0;
      }
      .serviceList{
        display: flex;
        li{
          padding: 0 15px;
          color: #FC5F35;
          line-height: 24px;
          cursor: pointer;
          font-size: 13px;
          white-space: nowrap;
          &.active{
            background: #FC5F35;
            color: #fff;
          }
        }
      }
    }
    .phoneInfo{
      display: flex;
      font-size: 12px;
      min-width: 200px;
      margin-top: 21px;
      img{
        width: 42px;
        height: 42px;
      }
      p{
        margin-left: 10px;
        span{
          display: block;
          text-align: left;
          white-space: nowrap;
          color: #999;
          &:nth-of-type(2){
            font-size: 22px;
            font-weight: 600;
            color: #fff;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/SearchBar.vue